/**
 * @file コンポーネント：プライバシーポリシー日本語 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPrivacypolicyBody = styled.article`
    padding: 16px;
    counter-reset: section;

    dl {
        counter-reset: list;

        > dd {
            margin-bottom: 8px;
        }

        > dt {
            margin-bottom: 8px;
            color: #6c757d;
            font-weight: normal;
            font-size: 11px;
            line-height: 1.5;

            &::before {
                margin-right: 4px;
                counter-increment: list;
                content: "(" counter(list) ")";
            }
        }
    }

    h3 {
        margin-bottom: 8px;
        color: #000000;
        font-size: 13px;
        line-height: 1.5;
    }

    h4 {
        margin-bottom: 8px;
        color: #000000;
        font-size: 12px;
        line-height: 1.5;

        &::before {
            margin-right: 4px;
            counter-increment: section;
            content: counter(section) ".";
        }
    }

    p {
        margin-bottom: 8px;
        color: #6c757d;
        font-size: 11px;
        line-height: 1.5;
    }

    section {
        margin-bottom: 16px;
    }

    ul {
        margin-left: 2em;

        > li {
            list-style-type: disc;
            color: #6c757d;
            font-size: 11px;
            line-height: 1.5;
        }
    }
`;
